import { gql } from '@apollo/client';

export const UPDATE_ORDER_CONFIRMATION_RECIPIENT = gql`
    mutation UpdateOrderConfirmationRecipient($data: OrderConfirmationRecipientUpdateInput!) {
        updateOrderConfirmationRecipient(data: $data) {
            name
        }
    }
`;
